import i18n from 'i18next';
import { NavigationStore } from '@24i/nxg-core-utils/src/globalSingletons';
import { Payload, TitleForSpecialScreens } from './types';

// we need to move this enum from smartott package to here (this package)
export enum SPECIAL_TRANSLATED_SCREENS {
    PLAYBACK = 'appstage-screen-player',
    DETAILS = 'appstage-screen-details',
    SEE_ALL = 'appstage-screen-see-all',
}

export enum SPECIAL_TRANSLATED_TV_SCREENS {
    PLAYBACK = 'Playback',
    DETAILS = 'Details',
    SEE_ALL = 'SeeAll',
}

export const handleTitleForSpecialScreens = ({
    screen,
    params,
    screenTitle,
}: TitleForSpecialScreens): string => {
    const genericTitle =
        params.payload?.params?.title ||
        params.payload?.params?.asset?.title ||
        params.payload?.asset?.title;

    const assetOnlyTitle = params.payload?.params?.asset?.title || params.payload?.asset?.title;

    switch (screen) {
        case SPECIAL_TRANSLATED_SCREENS.SEE_ALL:
        case SPECIAL_TRANSLATED_TV_SCREENS.SEE_ALL:
            return i18n.t('analytics.documentTitle.seeAll', { rowTitle: genericTitle });

        case SPECIAL_TRANSLATED_SCREENS.DETAILS:
        case SPECIAL_TRANSLATED_TV_SCREENS.DETAILS:
            return i18n.t('analytics.documentTitle.detail', { assetTitle: assetOnlyTitle });

        case SPECIAL_TRANSLATED_SCREENS.PLAYBACK:
        case SPECIAL_TRANSLATED_TV_SCREENS.PLAYBACK:
            return i18n.t('analytics.documentTitle.player', { assetTitle: genericTitle });

        default:
            return screenTitle || '';
    }
};

export const getFormattedOriginalSourcePage = (payload: Payload): string => {
    const previousState = NavigationStore.getPreviousState();
    return handleTitleForSpecialScreens({
        screen: previousState?.routeId || '',
        params: payload,
        screenTitle: previousState?.title,
    });
};
